import { connect } from 'react-redux';
import SingUpScreen from './screen';
import './styles.scss';
import {
  SignUpRequest,
  fetchCompanies,
} from '../../../redux/actions/SignupActions';

const mapStateToProps = (state) => {
  return {
    companiesList: state.SignUpReducer.companiesList,
    showTutorialScreen: state.CommonReducer.showTutorialScreen,
    loading: state.LoadingReducer.isLoading,
    isNetConnected: state.LoginReducer.isNetConnected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSignUpRequest: (signUpBody, callback) =>
      dispatch(SignUpRequest(signUpBody, callback)),
    fetchCompanies: (callback) => dispatch(fetchCompanies(callback)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SingUpScreen);
